import React from 'react';
import AuthService from './../../../../services/AuthService';
import RaisedButton from 'material-ui/RaisedButton';
import { withRouter } from 'react-router-dom'

export default class Block3 extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            rows:[]
        };
        this.Auth = new AuthService();
    }

    componentDidMount(){
        this.Auth.fetch('/societe/synthese/stats')
            .then(x=>this.setState({rows:x.data.payload}))
    }
    render() {
        const Btn = withRouter( ({ history }) => (<RaisedButton
            label={'Synthèse complète'}
            primary={true}
            onClick={()=>history.push('/entreprise/synthese')}
        />));
        return (
            <div className={'row'} style={{marginBottom:10, marginTop:10}}>
                <div className={'col'}>
                   <table className="table table-hover">
                       <thead>
                           <tr>
                               <th>Synthèse </th>
                               <th width="100" scope="col"></th>
                           </tr>
                       </thead>
                       <tbody>
                       {this.state.rows.map(x=>{
                           return(
                           <tr key={x.type}>
                               <td>{x.type}</td>
                               <td>{x.count}</td>
                           </tr>);
                       })}
                       </tbody>
                   </table>
                    <Btn/>

                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/indexBlocks/Block3.js